import store from "@/store"

export default {

    get paymentPlan() {
        return store.state.learnHow.learnHowPaymentPlan
    },

    set paymentPlan(paymentPlan) {
        store.commit("learnHow/updateLearnHowPaymentPlan", paymentPlan)
    },

    get drawerVisible() {
        return store.state.learnHow.learnHowDrawerVisible
    },

    set drawerVisible(visible) {
        store.commit("learnHow/updateLearnHowDrawerVisible", visible)
    },

    showDrawer(paymentPlan) {
        this.paymentPlan = paymentPlan
        this.drawerVisible = true
    },

    hideDrawer() {
        this.paymentPlan = null
        this.drawerVisible = false
    }
}
